module.exports = "/images/fk.svg?4ad3f587357cbef9eadef23819c0601b";